module.exports = __webpack_public_path__ + "static/media/additional_retreat_120.1ad914a8.png";